import CONFIG from "./config.json";

interface AppConfig {
  PRODUCT_NAME: string;
  VERSION: string;
  APP_ENV: string;
  API: {
    ROOT_URL: string;
    VERSION: string;
  };
  FEATURES?: {
    CONFIRMATION_OF_PAYEE?: boolean;
    REUSABLE_RTP_DASHBOARD?: boolean;
    SUBSCRIPTION?: boolean;
    SUBSCRIPTION_HISTORY?: boolean;
    SUBSCRIPTION_APIS_DISABLED?: boolean;
    GDPR_DASHBOARD?: boolean;
    UPDATE_USER?: {
      VIEW_USER?: {
        APPLY_BUTTON_ENABLED?: boolean;
      };
    };
  };
}

if (CONFIG.APP_ENV !== "production" || process.env.NODE_ENV !== "production") {
  console.info("App сonfiguration:", CONFIG);
} else {
  console.info(`v${CONFIG.VERSION}`);
}

export default CONFIG as AppConfig;
